import React, { PureComponent } from 'react';
import { string, bool } from 'prop-types';
import { crumbShape } from 'shapes';
import classnames from 'classnames';

export default class Crumb extends PureComponent {
    static propTypes = {
        className: string,
        crumb: crumbShape.isRequired,
        active: bool,
    };

    static defaultProps = {
        className: null,
        active: false,
    };

    render() {
        const { crumb, active, className } = this.props;
        const rootClassName = classnames('breadcrumb-root__item', className, {
            'breadcrumb-root__item--active': active,
        });

        return (
            <a
                href={crumb.url}
                className={rootClassName}
                data-qa="breadcrumbsItemLinkCta"
            >
                {crumb.label}
            </a>
        );
    }
}
